module.exports = __webpack_public_path__ + "static/media/git.9adb24dd.png";